'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components2 = require('components');

var _forms = require('metadata/forms');

var _pacomo = require('utils/pacomo');

var _utilityFunctions = require('utils/utilityFunctions');

var _utils = require('../../utils/mappings/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var intl = _ref.intl,
        id = _ref.id,
        name = _ref.name,
        label = _ref.label,
        input = _ref.input,
        hiddenValues = _ref.hiddenValues,
        type = _ref.type,
        fieldClass = _ref.fieldClass,
        requirement = _ref.requirement,
        placeholder = _ref.placeholder,
        helpText = _ref.helpText,
        options = _ref.options,
        hideDefaultSelectOption = _ref.hideDefaultSelectOption,
        _ref$meta = _ref.meta,
        active = _ref$meta.active,
        visited = _ref$meta.visited,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        customDisabled = _ref.customDisabled,
        customOnChange = _ref.customOnChange;

    var hideInput = false;
    if (hiddenValues) {
        var isHiddenValue = (0, _utilityFunctions.getResourceValue)(name, hiddenValues);
        hideInput = isHiddenValue;
        if (isHiddenValue && visited) {
            // TODO: make this less hacky?
            if (active || input.value !== '') {
                hideInput = false;
            }
        }
    }

    var isDisabled = function isDisabled() {
        return !requirement || !requirement.editable || !(0, _utils.hasPermission)(requirement) || (typeof customDisabled === "boolean" ? customDisabled : false);
    };

    var inputProps = (0, _extends3.default)({
        id: id
    }, input, {
        className: (0, _classnames2.default)(fieldClass || "field", { "check-input": type === "checkbox" }),
        disabled: isDisabled()
    });

    if (type === 'date' && !hideInput) {
        inputProps.min = "0000-01-01";
        inputProps.max = "9999-12-31";
    }

    var inputComponent = void 0;
    if (hideInput) {
        inputComponent = _react2.default.createElement('input', (0, _extends3.default)({}, inputProps, { value: '********', type: 'password' }));
    } else {
        switch (type) {
            case 'select':
                // SHI-1076: Display-only clear when the field is soft-disabled via customDisabled
                // (e.g. the Expedition Parka Size dropdown while its override is checked).
                // We override `value` on the <select> so the UI reflects the override state
                // without mutating redux-form state — preventing a stray jacket_sizes mutation
                // from riding along in an unrelated save.
                inputComponent = _react2.default.createElement(
                    'select',
                    (0, _extends3.default)({}, inputProps, { value: customDisabled ? '' : inputProps.value }),
                    !hideDefaultSelectOption && _react2.default.createElement(
                        'option',
                        { value: '' },
                        intl.formatMessage(_forms.formPlaceholders.generalSelect)
                    ),
                    options.map(function (_ref2, i) {
                        var value = _ref2.value,
                            label = _ref2.label;
                        return _react2.default.createElement(
                            'option',
                            { key: i, value: value },
                            label
                        );
                    })
                );
                break;
            case 'textarea':
                // Reset input on the next frame when customDisabled is enabled. Solves the Redux state transition race condition.
                if (requirement.editable && customDisabled) requestAnimationFrame(function () {
                    return input.onChange('');
                });

                inputComponent = _react2.default.createElement('textarea', inputProps);
                break;
            case 'combo':
                inputComponent = _react2.default.createElement(_components2.ComboboxInput, inputProps);
                break;
            case 'checkbox':
                // This should have been implemented as a class component since this project doesn't use React Hooks,
                // only class components support lifecycle methods like componentDidMount.
                // Because Input is an outdated functional component, we can't rely on lifecycle hooks to trigger behavior on mount.
                // As a workaround, we manually call customOnChange here during render to ensure other fields can react to the checkbox's initial value.
                // This isn't ideal, but it's necessary given the current structure.
                if (customOnChange) customOnChange(!!input.value);

                inputComponent = _react2.default.createElement('input', (0, _extends3.default)({}, inputProps, {
                    placeholder: type === 'date' && intl.formatMessage(_forms.formPlaceholders.dateFormat) || placeholder,
                    type: type }));
                break;
            default:
                inputComponent = _react2.default.createElement('input', (0, _extends3.default)({}, inputProps, {
                    placeholder: type === 'date' && intl.formatMessage(_forms.formPlaceholders.dateFormat) || placeholder,
                    type: type }));
        }
    }

    return _react2.default.createElement(
        'span',
        null,
        label && _react2.default.createElement(
            'label',
            { htmlFor: id },
            label
        ),
        inputComponent,
        _react2.default.createElement(_components2.FieldHelpErrorText, { touched: touched, error: error, helpText: helpText })
    );
};
Input.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    input: _propTypes2.default.object.isRequired,
    type: _propTypes2.default.string.isRequired,
    hiddenValues: _propTypes2.default.object,
    fieldClass: _propTypes2.default.string,
    requirement: _propTypes2.default.object,
    placeholder: _propTypes2.default.string,
    helpText: _propTypes2.default.object,
    options: _propTypes2.default.array,
    hideDefaultSelectOption: _propTypes2.default.bool,
    meta: _propTypes2.default.object.isRequired,
    label: _propTypes2.default.string
};

exports.default = (0, _reactIntl.injectIntl)((0, _pacomo.pacomoTransformer)(Input));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/Input.js
// module id = 633
// module chunks = 0